<template>
    <hts-drawer
        v-model="visible"
        size="large"
        :title="$t('labels.nodeModule.detailNode')"
        @close="closeOverSide">
        <div
            class="relative h-full w-full"
            :style="{ minWidth: minWidthScroll }">
            <div
                class="w-full h-full overflow-x-auto"
                style="max-height: calc(100% - 20px)">
                <div class="flex gap-2">
                    <div
                        class="w-1/2"
                        :class="sizeItemInput">
                        <hts-card :title="$t('labels.location')">
                            <hts-admincp-select-location
                                ref="selectLocation"
                                v-model="dataFormEditNode.location"
                                :text="dataFormEditNode.locationName"
                                name="location"
                                prop="location"
                                key-id="_id"
                                :label="$t('labels.locationName')"
                                key-label="locationName"
                                clearable
                                readonly />
                            <hts-form-input
                                v-model="dataFormEditNode.address"
                                :label="$t('labels.nodeModule.address')"
                                :color="props.color"
                                readonly
                                name="address"
                                prop="address" />
                        </hts-card>

                        <hts-card :title="$t('labels.nodeType')">
                            <div class="grid-cols-2 grid gap-4">
                                <hts-admincp-select-node-type
                                    v-model="dataFormEditNode.nodeType"
                                    v-model:text="dataFormEditNode.nodeTypeName"
                                    key-id="_id"
                                    key-label="name"
                                    readonly />
                                <template v-if="dataFormEditNode.nodeTypeName === 'Cảng'">
                                    <hts-form-input
                                        v-model="dataFormEditNode.portCode"
                                        label="Port CODE"
                                        readonly />
                                </template>

                                <add-toll-stations
                                    ref="addTollStations"
                                    disabled
                                    @update="(val) => (dataFormEditNode.tollStationsPrices = val)" />

                                <hts-form-button
                                    v-show="dataFormEditNode.nodeTypeName === 'Trạm thu phí' && !checkEnterTollStationsPrices"
                                    class="mt-9 text-center"
                                    color="warning"
                                    icon-name="hi-plus-circle-icon"
                                    icon-position="right"
                                    type="button"
                                    :outline="true"
                                    @click="openTollStationTariff">
                                    {{ $t('labels.tollStationTariff') }}
                                </hts-form-button>

                                <hts-form-button
                                    v-show="dataFormEditNode.nodeTypeName === 'Trạm thu phí' && checkEnterTollStationsPrices"
                                    class="mt-9 text-center"
                                    color="success"
                                    icon-name="hi-eye-icon"
                                    icon-position="right"
                                    type="button"
                                    :outline="true"
                                    @click="openTollStationTariff">
                                    {{ $t('labels.watchTollStationTariff') }}
                                </hts-form-button>

                                <div v-if="dataFormEditNode.nodeTypeName === 'Kho'">
                                    <hts-form-radio
                                        v-model="dataFormEditNode.warehouseType"
                                        :label="$t('labels.nodeModule.warehouseType')"
                                        value-key="value"
                                        name="warehouseType"
                                        prop="warehouseType"
                                        :items="listWarehouseType"
                                        readonly />
                                </div>
                            </div>

                            <span class="mt-3">
                                {{ $t('labels.businessTask') }}
                            </span>
                            <div
                                v-for="(business, index) in businessData"
                                :key="business">
                                <hts-form-disclosure
                                    color="main"
                                    size="large"
                                    :is-have-children="true">
                                    <template #reference>
                                        <div class="flex align-middle items-center gap-3 min-h-10 rounded-lg text-white bg-main-500 hover:bg-main-600 w-full">
                                            <input
                                                type="checkbox"
                                                :checked="Object.keys(dataFormEditNode.businesses).includes(business._id)"
                                                :value="business._id"
                                                class="w-[17.5px] h-[17.5px]"
                                                disabled
                                                @click="(e) => businessClick(e, business._id, business)" >
                                            <span>
                                                {{ business.name }}
                                            </span>
                                        </div>
                                    </template>
                                    <template #children>
                                        <div
                                            v-for="(task, subIndex) in business.tasks"
                                            :key="task">
                                            <div class="flex align-middle items-center gap-3 min-h-10 rounded-lg text-white mt-3 ml-10 p-2 pl-3 bg-main-400 hover:bg-main-600">
                                                <input
                                                    class="w-[17.5px] h-[17.5px]"
                                                    type="checkbox"
                                                    disabled
                                                    :checked="
                                                        Object.keys(dataFormEditNode.businesses).includes(business._id) && dataFormEditNode.businesses[business._id]?.includes(task._id)
                                                    "
                                                    :value="task._id"
                                                    @click="taskClick(business._id, task._id)" >
                                                <span>
                                                    {{ task.name }}
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                </hts-form-disclosure>
                            </div>
                        </hts-card>

                        <hts-card :title="$t('labels.generalInformation')">
                            <!--
                              <hts-admincp-select-company
                              v-model="dataFormEditNode.company"
                              v-model:text="dataFormEditNode.companyName"
                              :label="$t('labels.ownerCompany')"
                              :color="props.color"
                              name="ownerCompany"
                              prop="ownerCompany"
                              type="OWNER"
                              disabled />
                            -->
                            <working-time
                                v-model="dataFormEditNode.workingTime"
                                :disabled="true" />

                            <hts-form-checkbox
                                v-model="dataFormEditNode.holidayWorking"
                                :items="[{ label: $t('labels.holidayWorking'), value: true }]"
                                disabled />

                            <hts-form-checkbox
                                v-if="dataFormEditNode.holidayWorking"
                                v-model="dataFormEditNode.holidayWorkingOverTime"
                                class="ml-5"
                                :items="[{ label: $t('labels.nodeModule.overTime'), value: true }]"
                                disabled />

                            <hts-form-checkbox
                                v-model="dataFormEditNode.hasLoadLimit"
                                :items="[{ label: $t('labels.nodeModule.hasLoadLimit'), value: true }]"
                                disabled />
                            <hts-form-input
                                v-if="dataFormEditNode.hasLoadLimit"
                                v-model="dataFormEditNode.loadLimit"
                                :label="$t('labels.loadLimit')"
                                :color="props.color"
                                type="number"
                                name="loadLimit"
                                prop="loadLimit"
                                readonly />

                            <!--  Loại xe, cont -->
                            <hts-form-checkbox
                                v-model="dataFormEditNode.liftingVehicleReceivingForce"
                                class="w-full"
                                type="list"
                                :label="$t('labels.liftingVehicleReceivingForce')"
                                :items="[
                                    { label: $t('labels.containerTruck'), value: 'container-truck' },
                                    { label: $t('labels.truck'), value: 'truck' }
                                ]"
                                disabled />
                            <div class="grid gap-4 grid-cols-2">
                                <div>
                                    <hts-form-select
                                        v-show="dataFormEditNode.liftingVehicleReceivingForce.includes('container-truck')"
                                        v-model="dataFormEditNode.contCategory"
                                        :label="$t('labels.containerType')"
                                        multiple
                                        :items="dataSelectWorkFlowData"
                                        key-id="value"
                                        key-label="label"
                                        prop="containerType"
                                        name="containerType"
                                        :color="props.color"
                                        readonly />
                                </div>
                                <div>
                                    <hts-form-input
                                        v-show="dataFormEditNode.liftingVehicleReceivingForce.includes('truck')"
                                        v-model="dataFormEditNode.maximumLoad"
                                        :label="$t('labels.maximumLoad')"
                                        :color="props.color"
                                        type="number"
                                        name="maximumLoad"
                                        prop="maximumLoad"
                                        readonly>
                                        <template #custom>
                                            <hts-tooltip class="mt-2 ml-2">
                                                <div>
                                                    <span class="font-bold">
                                                        {{ $t('labels.maximumVehicleLoadWarning') }}
                                                    </span>
                                                </div>
                                                <template #reference>
                                                    <hi-information-circle-icon class="flex items-center text-green-500 w-6 h-6" />
                                                </template>
                                            </hts-tooltip>
                                        </template>
                                    </hts-form-input>
                                </div>
                            </div>
                        </hts-card>

                        <hts-card :title="$t('labels.liftingCommodityReceivingForce')">
                            <hts-form-checkbox
                                v-model="dataFormEditNode.typeReefer"
                                :label="$t('labels.isReefer')"
                                value-key="value"
                                :items="listRadioReeferTypes"
                                disabled />
                            <hts-form-checkbox
                                v-model="dataFormEditNode.typeDangerous"
                                :label="$t('labels.isDangerous')"
                                disabled
                                value-key="value"
                                :items="listRadioDangerousTypes" />
                            <hts-form-checkbox
                                v-model="dataFormEditNode.typeFragileGoods"
                                :label="$t('labels.isFragile')"
                                disabled
                                value-key="value"
                                :items="listRadioFragileTypes" />
                            <!--
                              <hts-form-checkbox
                              v-model="dataFormEditNode.goodType"
                              :label="$t('labels.goodsTypes')"
                              disabled
                              value-key="value"
                              :items="listRadioGoodTypes" />
                            -->
                            <!--
                              <hts-form-checkbox
                              v-model="dataFormEditNode.typeCommodity"
                              :label="$t('labels.overweightCargo2')"
                              disabled
                              value-key="value"
                              name="overweightCargo2"
                              prop="overweightCargo2"
                              :items="listRadioTypeCommodity" />
                            -->
                        </hts-card>

                        <hts-form-input
                            v-model="dataFormEditNode.description"
                            :label="$t('labels.description')"
                            :color="props.color"
                            name="description"
                            prop="description"
                            readonly
                            class="mb-8" />

                        <div class="h-8 min-h-8" />
                    </div>
                    <div class="w-1/2 h-full ml-5" />
                </div>
            </div>

            <div
                class="w-1/2 absolute right-0 top-0 h-full pl-2"
                style="max-height: calc(100% - 100px)">
                <hts-map-node
                    :node-list="locationList"
                    :center-position="nodePosition"
                    center-marker
                    @clickMarker="handleSelectMyLocation" />
            </div>
        </div>

        <add-location
            ref="addLocation"
            @refresh-tables="getAllNodeLocation"
            @newLocation="newLocation" />
    </hts-drawer>
</template>

<script setup lang="ts">
import AddLocation from '../location/ignore/add.vue'
import dataForm from './imports/model'
import AddTollStations from './node/toll-stations.vue'
import WorkingTime from './node/working-time.vue'

import screen from '~/components/utils/screen'

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: Number,
    default: 0
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  nodeTypes: {
    type: Array,
    default: () => {}
  }
})
const store = $store()
const dataFormEditNode = reactive({ ...dataForm.initEditValue })
const nodePosition = reactive({
  lat: 10.7561542,
  lng: 106.6896784
})
const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm}px`
})

const emits = defineEmits(['close', 'refreshTables'])

const visible = ref(false)
const locationList = ref<Array<{ [key: string]: any }>>([])
const businessData = ref<{ [key: string]: string }>()
const changeBussiness = ref(false)
const addTollStations = ref()
const changeTollStationsPrices = ref(false)
const addLocation = ref()
const selectLocation = ref()

const cRules = computed(() => {
  const rules: any = {
    location: 'required',
    nodeType: 'required'
  }

  if (dataFormEditNode.hasLoadLimit) {
    rules.loadLimit = 'required'
  }

  return rules
})

const openEditNode = async (id: string) => {
  visible.value = true
  await getData(id)
  await getAllNodeLocation()
}

const openAddLocation = () => {
  if (addLocation?.value) {
    if (selectLocation.value) {
      selectLocation.value.hide()
    }
    addLocation?.value.open()
  }
}

const getData = async (id: string) => {
  const api = $urlAdmin.node.getById
  const data: any = await $api(api, { uriParams: { ID: id } })
  const resData: any = data.data.value
  if (resData.success) {
    const nodeData: any = resData.data

    if (nodeData?.location?.lat && nodeData?.location?.lng) {
      nodePosition.lat = Number(nodeData?.location?.lat)
      nodePosition.lng = Number(nodeData?.location?.lng)
    } else {
      nodePosition.lat = 10.7561542
      nodePosition.lng = 106.6896784
    }

    dataFormEditNode.id = nodeData?._id || ''
    dataFormEditNode.company = nodeData?.company?._id || ''
    dataFormEditNode.companyName = nodeData?.company?.name || ''
    dataFormEditNode.location = nodeData?.location?._id || ''
    dataFormEditNode.locationName = nodeData?.location?.locationName || ''
    dataFormEditNode.portCode = nodeData?.portCode || ''
    dataFormEditNode.address = nodeData?.location?.address || ''
    dataFormEditNode.hasLoadLimit = nodeData?.hasLoadLimit || false
    dataFormEditNode.loadLimit = nodeData?.hasLoadLimit ? nodeData?.loadLimit : null
    dataFormEditNode.liftingVehicleReceivingForce = nodeData?.liftingVehicleReceivingForce || []
    dataFormEditNode.contCategory = nodeData?.contCategory && nodeData?.contCategory.length ? nodeData.contCategory : [20, 40, 45]
    dataFormEditNode.maximumLoad = typeof nodeData.maximumLoad === 'number' ? nodeData.maximumLoad : null
    dataFormEditNode.typeCommodity = nodeData?.typeCommodity || []
    dataFormEditNode.goodType = nodeData?.goodType || []
    dataFormEditNode.typeReefer = nodeData?.typeReefer || []
    dataFormEditNode.typeDangerous = nodeData?.typeDangerous || []
    dataFormEditNode.typeFragileGoods = nodeData?.typeFragileGoods || []
    dataFormEditNode.nodeType = nodeData?.nodeType?._id || ''
    dataFormEditNode.nodeTypeName = nodeData?.nodeType?.name || ''
    dataFormEditNode.warehouseType = nodeData?.warehouseType || ''
    dataFormEditNode.businesses = nodeData?.businesses || {}
    dataFormEditNode.workingTime = nodeData?.workingTime || {
      mon: [],
      tue: [],
      wed: [],
      thu: [],
      fri: [],
      sat: [],
      sun: []
    }
    dataFormEditNode.holidayWorking = nodeData?.holidayWorking || false
    dataFormEditNode.holidayWorkingOverTime = nodeData?.holidayWorkingOverTime || false
    dataFormEditNode.description = nodeData?.description || ''
    const tollStationStructure = store.data.tollStationStructure

    const dataPrices: any = {
      vehicle: {},
      cont: {}
    }
    if (tollStationStructure && Array.isArray(tollStationStructure.vehicle)) {
      tollStationStructure.vehicle.forEach((item: any) => {
        if (nodeData?.tollStationsPrices?.vehicle?.[item.id]) {
          dataPrices.vehicle[item.id] = nodeData.tollStationsPrices.vehicle[item.id]
        } else {
          dataPrices.vehicle[item.id] = {
            trip: null,
            month: null,
            quarter: null
          }
        }
      })
    }

    if (tollStationStructure && Array.isArray(tollStationStructure.cont)) {
      tollStationStructure.cont.forEach((item: number) => {
        if (nodeData?.tollStationsPrices?.cont?.[item]) {
          dataPrices.cont[item] = nodeData.tollStationsPrices.cont[item]
        } else {
          dataPrices.cont[item] = {
            trip: null,
            month: null,
            quarter: null
          }
        }
      })
    }
    dataFormEditNode.tollStationsPrices = dataPrices
  }
  if (!dataFormEditNode.nodeType) {
    changeBussiness.value = true
  } else {
    changeBussiness.value = false
  }
  changeTollStationsPrices.value = false
}

defineExpose({
  openEditNode
})

const closeOverSide = () => {
  undo()
  visible.value = false
}
const undo = () => {
  Object.assign(dataFormEditNode, {
    ...dataForm.initValue
  })
  dataFormEditNode.businesses = []
  dataFormEditNode.workingTime = {
    mon: [],
    tue: [],
    wed: [],
    thu: [],
    fri: [],
    sat: [],
    sun: []
  }
  dataFormEditNode.tollStationsPrices = {
    vehicle: {},
    cont: {}
  }
  dataFormEditNode.hasLoadLimit = false
  dataFormEditNode.liftingVehicleReceivingForce = []
  dataFormEditNode.contCategory = []
  dataFormEditNode.typeCommodity = ['NORMAL']
  dataFormEditNode.goodType = ['SOLID']
  dataFormEditNode.typeReefer = ['NOTREEFER']
  dataFormEditNode.typeDangerous = ['NOTDANGEROUS']
  dataFormEditNode.typeFragileGoods = ['NOTFRAGILE']
  businessData.value = {} as any
}

const handleSubmitFormEditNode = () => {
  if (!checkEnterWorkingTime('inTime')) {
    process.client && $toast().error('Vui lòng nhập thời gian làm việc trong giờ')
    return
  }

  if (!checkBusinessAndTask()) {
    return
  }

  if (dataFormEditNode.nodeTypeName === 'Trạm thu phí' && !checkTollStationsPrices()) {
    return
  }
  const api = $urlAdmin.node.update

  $api(api, { body: dataFormEditNode })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        emits('refreshTables')
        process.client && $toast().success($t('labels.nodeModule.editSuccess'))
        emits('close')
        undo()
      }
      visible.value = false
    })
    .catch((error: any) => error)
}

const checkEnterWorkingTime = (type: string) => {
  try {
    for (const day in dataFormEditNode.workingTime) {
      const dayTimeSlots = dataFormEditNode.workingTime[day]
      for (const timeSlot of dayTimeSlots) {
        if (timeSlot.type === type) {
          return true
        }
      }
    }
    return false
  } catch (e) {
    return false
  }
}

const newLocation = (data: any) => {
  if (data?._id && data?.locationName && data?.address) {
    dataFormEditNode.location = data?._id
    dataFormEditNode.locationName = data?.locationName
    dataFormEditNode.address = data?.address
  }

  if (data?.lat && data.lng) {
    nodePosition.lat = Number(data?.lat)
    nodePosition.lng = Number(data?.lng)
  }
}

const checkBusinessAndTask = () => {
  try {
    if (dataFormEditNode.businesses && Object.keys(dataFormEditNode.businesses).length === 0) {
      process.client && $toast().error($t('labels.pleaseSelectBusiness'))
      throw new Error('No business selected')
    }

    Object.keys(dataFormEditNode.businesses).forEach((business: string) => {
      if (dataFormEditNode.businesses[business].length === 0) {
        process.client && $toast().error($t('labels.pleaseSelectTask'))
        throw new Error('No task selected')
      }
    })
    return true
  } catch (e) {
    return false
  }
}

const checkTollStationsPrices = () => {
  if (!store.data.getTollStationStructure) {
    process.client && $toast().error($t('labels.pleaseInstallTollStationTariffStructure'))
    return false
  }

  const vehiclePricesData = dataFormEditNode.tollStationsPrices.vehicle
  if (Object.keys(vehiclePricesData).length === 0) {
    process.client && $toast().error($t('labels.pleaseEnterTripTickets'))
    return false
  }

  for (const item in vehiclePricesData) {
    if (typeof vehiclePricesData[item].trip !== 'number') {
      process.client && $toast().error($t('labels.pleaseEnterTripTickets'))
      return false
    }
  }

  const contPricesData = dataFormEditNode.tollStationsPrices.cont

  for (const item in contPricesData) {
    if (typeof contPricesData[item].trip !== 'number') {
      process.client && $toast().error($t('labels.pleaseEnterTripTickets'))
      return false
    }
  }
  return true
}

// select option location
const handleChangeLocation = (val: { [key: string]: any }) => {
  // change của select option trả về array những item đã chọn
  dataFormEditNode.address = val[0]?.address || ''
  nodePosition.lat = Number(val[0]?.lat) || 10.7561542
  nodePosition.lng = Number(val[0]?.lng) || 106.6896784
}

// map click marker location
const handleSelectMyLocation = (val: any) => {
  // chi tiết location được thêm và marker lúc getAllNodeLocation
  const data = val.data

  dataFormEditNode.location = data?._id
  dataFormEditNode.locationName = data?.locationName
  dataFormEditNode.address = data?.address
}

// autocomlete gg map để nhảy đến vị trí trên bản đồ
const handleChoosePosition = async (data: any) => {
  const geocoder = new google.maps.Geocoder()
  const placeInfo = await geocoder.geocode({ placeId: data.place_id })

  if (placeInfo && Array.isArray(placeInfo.results) && placeInfo.results.length > 0) {
    nodePosition.lat = placeInfo.results[0].geometry.location?.lat()
    nodePosition.lng = placeInfo.results[0].geometry.location?.lng()
  }
}

const getAllNodeLocation = async () => {
  const api = $urlAdmin.node.location.getAll
  const data: any = await $api(api)
  const resData = data.data.value

  if (resData?.success) {
    const list = resData.data
    locationList.value = list.map((item: any) => ({
      position: {
        lat: parseFloat(item.lat),
        lng: parseFloat(item.lng)
      },
      isNewLocation: item.newLocation,
      icon: item.newLocation ? '/assets/new-location.png' : '/assets/location.png',
      title: item.locationName,
      placeId: item.placeId,
      data: item
    }))
  }
}

watch(
  () => dataFormEditNode.nodeType,
  async (val) => {
    // lấy thông tin nghiệp vụ
    const api = $urlAdmin.business.getByNodeType
    if (!val) {
      return
    }

    const data: any = await $api(api, { uriParams: { ID: val } })
    const resData = data?.data?.value
    if (resData?.success) {
      // data update UI
      businessData.value = resData.data
      // data save
      if (changeBussiness.value) {
        const businesses: { [key: string]: string[] } = resData.data.reduce((acc: any, business: any) => {
          const taskIds = business.tasks.map((task: any) => task._id)
          acc[business._id] = taskIds
          return acc
        }, {})
        dataFormEditNode.businesses = businesses
      }
      changeBussiness.value = true
    }
  }
)

watch(
  () => dataFormEditNode.nodeTypeName,
  (val) => {
    if (val === 'Trạm thu phí') {
      changeTollStationsPrices.value && getTollStationStructure()
    } else {
      dataFormEditNode.tollStationsPrices = {
        vehicle: {},
        cont: {}
      }
    }

    changeTollStationsPrices.value = true

    if (val !== 'Kho') {
      dataFormEditNode.warehouseType = ''
    }
  }
)

const businessClick = (e: any, id: string, business: any) => {
  e.stopPropagation()
  if (!Object.keys(dataFormEditNode.businesses).includes(id)) {
    dataFormEditNode.businesses[id] = business.tasks.map((task: any) => task._id)
  } else {
    const newObj = Object.keys(dataFormEditNode.businesses).reduce((acc: any, key: any) => {
      if (key !== id) {
        acc[key] = dataFormEditNode.businesses[key]
      }
      return acc
    }, {})

    dataFormEditNode.businesses = newObj
  }
}

const taskClick = (businessId: string, taskId: string) => {
  if (Object.keys(dataFormEditNode.businesses).includes(businessId)) {
    if (!dataFormEditNode.businesses[businessId].includes(taskId)) {
      dataFormEditNode.businesses[businessId].push(taskId)
    } else {
      dataFormEditNode.businesses[businessId] = dataFormEditNode.businesses[businessId].filter((item: any) => item !== taskId)
    }
  } else {
    dataFormEditNode.businesses[businessId] = [taskId]
  }
}

const openTollStationTariff = () => {
  if (addTollStations.value) {
    addTollStations.value.open(dataFormEditNode.tollStationsPrices)
  }
}

const getTollStationStructure = () => {
  const data: { vehicle: { [key: string]: any }; cont: { [key: number]: any } } = { vehicle: {}, cont: {} } as any

  const tollStationStructure = store.data.tollStationStructure

  if (!tollStationStructure) {
    return
  }

  if (tollStationStructure?.vehicle && Array.isArray(tollStationStructure.vehicle)) {
    tollStationStructure.vehicle.forEach((item: any) => {
      data.vehicle[item.id] = {
        trip: null,
        month: null,
        quarter: null
      }
    })
  }

  if (tollStationStructure?.cont && Array.isArray(tollStationStructure.cont)) {
    tollStationStructure?.cont.forEach((item: number) => {
      data.cont[item] = {
        trip: null,
        month: null,
        quarter: null
      }
    })
  }

  dataFormEditNode.tollStationsPrices = data
}

const checkEnterTollStationsPrices = computed(() => {
  return traverseObject(dataFormEditNode.tollStationsPrices)
})

const traverseObject = (obj: any) => {
  let foundNumber = false

  const traverse = (obj: any) => {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key]

        if (Array.isArray(value)) {
          value.forEach(function (item) {
            if (typeof item === 'object' && item !== null) {
              traverse(item)
            } else if (typeof item === 'number') {
              foundNumber = true
            }
          })
        } else if (typeof value === 'object' && value !== null) {
          traverse(value)
        } else if (typeof value === 'number') {
          foundNumber = true
        }
      }
    }
  }

  traverse(obj)

  return foundNumber
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }
  return 'grid-cols-5'
})

const dataSelectWorkFlowData = [
  {
    value: 20,
    label: $t('labels.vehicleModule.20ft')
  },
  {
    value: 40,
    label: $t('labels.vehicleModule.40ft')
  },
  {
    value: 45,
    label: $t('labels.vehicleModule.45ft')
  }
]

const listRadioTypeCommodity = [
  { value: 'NORMAL', label: $t('labels.ordinaryGoods') },
  { value: 'OVERWEIGHT', label: $t('labels.overweightCargo') }
]
const listRadioGoodTypes = [
  { value: 'SOLID', label: $t('labels.solid') },
  { value: 'LIQUID', label: $t('labels.liquid') },
  { value: 'GAS', label: $t('labels.gas') }
]
const listRadioReeferTypes = [
  { value: 'NOTREEFER', label: $t('labels.no') },
  { value: 'REEFER', label: $t('labels.true') }
]
const listRadioDangerousTypes = [
  { value: 'NOTDANGEROUS', label: $t('labels.notDangerous') },
  { value: 'DANGEROUS', label: $t('labels.dangerous') }
]
const listRadioFragileTypes = [
  { value: 'NOTFRAGILE', label: $t('labels.notFragile') },
  { value: 'FRAGILE', label: $t('labels.fragile') }
]

const listWarehouseType = [
  { value: 'BONDED', label: $t('labels.nodeModule.bonded') },
  { value: 'NORMAL', label: $t('labels.nodeModule.normal') }
]
</script>
